import React from "react";

const FormSubmitButton = ({
  label = "Submit",
  loading = false,
  type = "submit",
  color = "primary",
  align = "end",
  colSize = "col-12", 
  disabled = false,
  className = "",
  onClick
}) => {
  return (
    <div className={`${colSize} align-items-center d-flex justify-content-${align}`}>
      <button
        type={type}
        className={`btn btn-${color} ${className}`}
        disabled={loading || disabled}
        onClick={onClick}
      >
        {loading ? "Saving..." : label}
      </button>
    </div>
  );
};

export default FormSubmitButton;
